"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .fade-scale {\n    &-enter-active, &-exit-active {\n      transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;\n      transform-origin: 50% 300px;\n    }\n    &-enter {\n      opacity: 0;\n      transform: scale(0.98);\n      &-active {\n        opacity: 1;\n        transform: none;\n      }\n    }\n    &-exit {\n      opacity: 1;\n      transform: none;\n      &-active {\n        opacity: 0;\n        transform: scale(0.98);\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transitions = void 0;

var styled_components_1 = require("styled-components");

exports.Transitions = (0, styled_components_1.createGlobalStyle)(_templateObject());